import { gql } from '@apollo/client';
export const transactionErrorFragment = gql `
  fragment transactionErrorFields on ResponseError {
    type
    details
  }
`;
//# sourceMappingURL=transactionError.js.map